import { MutableRefObject, useRef } from 'react'
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect'

export function useLatest<T>(val: T): MutableRefObject<T> {
  const ref = useRef(val)
  useIsomorphicLayoutEffect(() => void (ref.current = val), [val])
  return ref
}
